import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';

import Entities from 'STORE';

import styles from './RightSidebarManager.styles.m.css';

export const RightSidebarManager: FC = observer(() => {
  useEffect(() => {
    return () => Entities.RightSidebar.reset();
  }, []);

  const items = Entities.RightSidebar.data;
  const lastItem = items[items.length - 1];

  if (!items.length || !lastItem) {
    return null;
  }

  const { component: Component, componentProps } = lastItem;

  return (
    <div className={styles.container}>
      <Component {...componentProps} />
    </div>
  );
});
